import React, { useCallback, useContext, useState, useEffect } from "react";
import { isNil } from "lodash";
import "./createMediaRequest.scss";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  Divider,
  List,
  ListItem,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
  CREATE_MEDIA,
  NAMESPACE_TO_ID_TYPE_MAPPING,
  SUPPLEMENTARY_ASSET_TYPE,
  IMAGE_TYPE,
  IMAGE_ENCODING,
} from "../../../constants/CreateMediaRequest";
import { MediaRequestContext } from "../../../context/MediaRequestContext";
import { ConfigContext } from "../../../security/ConfigContext";
import { getEditRate } from "./util";

const DubCards = ({ manifestation, assetTitle, entityType }) => {
  const [expanded, setExpanded] = useState(false);
  const {
    selectedFiles,
    _setSelectedFiles,
    handleSelectFile,
    _setIdAccordionExpanded,
    validAssets,
    idAccordionExpanded,
    titleAccordionExpanded,
    _setTitleAccordionExpanded,
    transferRegion,
    renamedFilename,
    getAssetType,
    getSourceId,
    getSourceIdNamespace,
  } = useContext(MediaRequestContext);
  const config = useContext(ConfigContext);
  const editRate = getEditRate(manifestation.editRate);
  const { environment } = config[0].app;
  let totalDubCardsAvailable = 0;

  manifestation?.containers?.forEach((container) => {
    manifestation?.supplementaryAssets?.forEach((supplementaryAsset) => {
      if (
        supplementaryAsset.supplementaryAssetType?.includes("image") &&
        supplementaryAsset.containerReference?.containerId ===
          container.containerId
      ) {
        totalDubCardsAvailable += 1;
      }
    });
  });

  const handleSelectAllFile = (e) => {
    let selectedFileDetails = { ...selectedFiles };
    manifestation.containers?.forEach((container) => {
      if (container.path) {
        const pathSplit = container.path?.split(".");
        const format = pathSplit[pathSplit.length - 1];
        const file = `${container.containerId}.${format}`;
        manifestation.supplementaryAssets?.forEach((supplementaryAsset) => {
          const dubCard =
            supplementaryAsset.supplementaryAssetType?.includes("image") &&
            supplementaryAsset.containerReference?.containerId ===
              container.containerId;
          if (dubCard) {
            if (e.target.checked) {
              if (file in selectedFileDetails) {
                selectedFileDetails[file]["isChecked"] = true;
                if (transferRegion[manifestation?.id] === "GCSSNY-MX_Content App") {
                  selectedFileDetails[file]["sourceUri"] = container.path;
                  selectedFileDetails[file]["containerId"] = container.containerId;
                }
              } else {
                const alternateId = getSourceId(manifestation);
                const idNamespace = getSourceIdNamespace(manifestation);
                const manifestationId = manifestation?.id;
                const assetType = getAssetType(entityType);
                selectedFileDetails = {
                  ...selectedFileDetails,
                  [file]: {
                    id: alternateId,
                    namespace: idNamespace,
                    idType: NAMESPACE_TO_ID_TYPE_MAPPING[idNamespace],
                    fileType: "Dub Card",
                    title: assetTitle,
                    transfer: transferRegion[manifestationId],
                    renamePrefix: isNil(assetType)
                      ? `${assetTitle.replace(
                          /\s+/g,
                          ""
                        )}_${editRate}`
                      : `${assetTitle.replace(/\s+/g, "")}_${assetType}_${editRate}`,
                    renamedFilename: renamedFilename[file],
                    ...(transferRegion[manifestationId] === "GCSSNY-MX_Content App" && {
                      sourceUri: container.path,
                      containerId: container.containerId,
                    }),
                    isChecked: true,
                    isMamProxy: false,
                  },
                };
              }
            } else {
              selectedFileDetails[file]["isChecked"] = false;
            }
            _setSelectedFiles(selectedFileDetails);
          }
        });
      }
    });
  };

  const areAllCheckboxesChecked = useCallback(() => {
    let existingDubCards = {};
    manifestation.containers?.forEach((container) => {
      if (container.path) {
        const pathSplit = container.path?.split(".");
        const format = pathSplit[pathSplit.length - 1];
        const file = `${container.containerId}.${format}`;
        manifestation.supplementaryAssets?.forEach((supplementaryAsset) => {
          const dubCard =
            supplementaryAsset.supplementaryAssetType?.includes("image") &&
            supplementaryAsset.containerReference?.containerId ===
              container.containerId;
          if (dubCard) {
            existingDubCards[file] = true;
          }
        });
      }
    });
    for (const fileName in existingDubCards) {
      if (!selectedFiles[fileName]?.isChecked) {
        return false;
      }
    }
    return true;
  }, [
    manifestation.supplementaryAssets,
    manifestation.containers,
    selectedFiles,
  ]);

  const isDisabled = useCallback(() => {
    for (const container of manifestation.containers) {
      for (const supplementaryAsset of manifestation.supplementaryAssets) {
        const dubCard =
          supplementaryAsset.supplementaryAssetType?.includes("image") &&
          supplementaryAsset.containerReference?.containerId ===
            container.containerId;
        if (dubCard) {
          if (
            environment === "uat" &&
            !container["path"].includes(environment)
          ) {
            if (!container["path"].includes("sit")) {
              return true;
            }
          } else {
            if (!container["path"].includes(environment)) {
              return true;
            }
          }
        }
      }
    }
    return false;
  }, [
    manifestation.supplementaryAssets,
    manifestation.containers,
    environment,
  ]);

  const isPathInvalid = (path) => {
    if (environment === "uat" && !path.includes(environment)) {
      if (!path.includes("sit")) {
        return true;
      }
    } else {
      if (!path.includes(environment)) {
        return true;
      }
    }
    return false;
  };

  const handleChange = (file) => (e) => {
    handleSelectFile(e, file, "Dub Card", manifestation, assetTitle, editRate, entityType);
  };
  
  const getDubCardsAccordionDetails = (supplementaryAssets, containers) =>
    containers?.map((container) => {
      if (container.path) {
        const pathSplit = container.path?.split(".");
        const format = pathSplit[pathSplit.length - 1];
        const file = `${container.containerId}.${format}`;
        return (
          <>
            {supplementaryAssets?.map(
              (supplementaryAsset) =>
                supplementaryAsset.supplementaryAssetType?.includes("image") &&
                supplementaryAsset.containerReference?.containerId ===
                  container.containerId && (
                  <>
                    <Divider />
                    <div className="mt-10" key={`dub-cards-container-${file}`}>
                      <span>
                        <Checkbox
                          className="pt-6"
                          onChange={handleChange(file)}
                          checked={selectedFiles[file]?.isChecked || false}
                          disabled={isPathInvalid(container["path"])}
                        />
                      </span>
                      <span className="font-bold word-break-all">{renamedFilename[file]}</span>
                    </div>
                    <Divider />
                    <div className="mt-10" key={`dub-cards-path-${file}`}>
                      <span className="font-bold">{CREATE_MEDIA.pathLabel}</span>
                      <span className="word-break-all">{container.path}</span>
                    </div>
                    <List
                      className="media-desc-list"
                      key={`dub-cards-description-${file}`}
                    >
                      {getDubCardDetails(supplementaryAsset)}
                    </List>
                  </>
                )
            )}
          </>
        );
      }
      return null;
    });

  const getDubCardDetails = (supplementaryAsset) => {
    const supplementaryAssetType =
      SUPPLEMENTARY_ASSET_TYPE[supplementaryAsset.supplementaryAssetType];
    const language = supplementaryAsset.writtenLanguage || "Unknown";
    const sequence = supplementaryAsset.sequence;
    const imageType = IMAGE_TYPE[supplementaryAsset.imageType] || "Unknown";
    const imageEncoding =
      IMAGE_ENCODING[supplementaryAsset.attributes?.encoding] || "Unknown";
    const frameSize = `${supplementaryAsset.attributes?.frameSize?.width} x ${supplementaryAsset.attributes?.frameSize?.height}`;
    const dubCardDescription = `Dub Card (${supplementaryAssetType}, ${language})`;
    return (
      <>
        <ListItem
          className="media-desc-list-item"
          key={`dub-card-description-${language}-${supplementaryAssetType}}`}
        >
          {dubCardDescription}
        </ListItem>
        <ListItem
          className="media-desc-list-item"
          key={`dub-card-description-sequence-${sequence}`}
        >
          {`Sequence: ${sequence}`}
        </ListItem>
        <ListItem
          className="media-desc-list-item"
          key={`dub-card-description-image-type-${imageType}`}
        >
          {`Image Type: ${imageType}`}
        </ListItem>
        <ListItem
          className="media-desc-list-item"
          key={`dub-card-description-image-encoding-${imageEncoding}`}
        >
          {`Image Encoding: ${imageEncoding}`}
        </ListItem>
        <ListItem
          className="media-desc-list-item"
          key={`dub-card-description-frame-size`}
        >
          {`Frame Size: ${frameSize}`}
        </ListItem>
      </>
    );
  };

  useEffect(() => {
    const idAccStructure = { ...idAccordionExpanded };
    const titleAccStructure = { ...titleAccordionExpanded };
    const handleAccordionExpansion = () => {
      Object.keys(validAssets).forEach((validAssetsKey) => {
        idAccStructure[validAssetsKey] = true;
        titleAccStructure[validAssetsKey] = true;
      });
      setExpanded(true);
      _setTitleAccordionExpanded(titleAccStructure);
      _setIdAccordionExpanded(idAccStructure);
    };
    manifestation.containers?.forEach((container) => {
      if (container.path) {
        const pathSplit = container.path?.split(".");
        const format = pathSplit[pathSplit.length - 1];
        const file = `${container.containerId}.${format}`;
        manifestation.supplementaryAssets?.forEach((supplementaryAsset) => {
          const dubCard =
            supplementaryAsset.supplementaryAssetType?.includes("image") &&
            supplementaryAsset.containerReference?.containerId ===
              container.containerId;
          if (
            dubCard &&
            file in selectedFiles &&
            selectedFiles[file]["isChecked"]
          ) {
            handleAccordionExpansion();
          }
        });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manifestation.supplementaryAssets, manifestation.containers]);

  return (
    <>
      {totalDubCardsAvailable === 0 && null}
      {totalDubCardsAvailable > 0 && (
        <Accordion
          classes={{
            expanded: "media-accordion",
          }}
          className="media-assets-accordion"
          variant="outlined"
          expanded={expanded}
          onChange={(e, expanded) => {
            setExpanded(expanded);
          }}
        >
          <AccordionSummary
            className="media-asset-container-accordion-summary"
            expandIcon={<ExpandMoreIcon />}
            IconButtonProps={{ style: { color: "white" } }}
          >
            {CREATE_MEDIA.dubCardsLabel}
          </AccordionSummary>
          <AccordionDetails className="media-asset-accordion-details">
            <div>
              <span>
                <Checkbox
                  className="pt-6"
                  onChange={(e) => handleSelectAllFile(e)}
                  checked={areAllCheckboxesChecked() || false}
                  disabled={isDisabled() || false}
                />
              </span>
              <span>{CREATE_MEDIA.selectAllDubCardsLabel}</span>
            </div>
            {getDubCardsAccordionDetails(
              manifestation?.supplementaryAssets,
              manifestation?.containers
            )}
          </AccordionDetails>
        </Accordion>
      )}
    </>
  );
};

DubCards.defaultProps = {
  manifestation: {},
  assetTitle: "",
  entityType: "",
};

export default DubCards;
